import api from '../api/client';

export const faturamentoService = {
  // Faturar lote
  faturarLote: async (organizadorId, loteId, dadosFaturamento) => {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/faturar`, dadosFaturamento);
    return response.data;
  },

  // Desfazer negociação
  desfazerNegociacao: async (organizadorId, loteId) => {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/desfazer-negociacao`);
    return response.data;
  },

  // Marcar como defesa
  marcarComoDefesa: async (organizadorId, loteId, valorDefesa) => {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/defesa`, { valor_defesa: valorDefesa });
    return response.data;
  },

  // Resetar lote
  resetarLote: async (organizadorId, loteId) => {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/resetar`);
    return response.data;
  },

  // Log de troca de comissão (individual <-> alternativa) confirmada na tela de
  // faturamento, independente de faturar ou não em seguida
  logTrocaComissao: async (organizadorId, loteId, dados) => {
    const response = await api.post(`/organizadores/${organizadorId}/lotes/${loteId}/log-troca-comissao`, dados);
    return response.data;
  }
};
